var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('div',{staticClass:"empty-state-icon"},[_c('v-icon',{attrs:{"size":"30","color":"#9aa2ab"}},[_vm._v(_vm._s(_vm.icon))])],1),_c('span',{staticClass:"empty-state-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.text)?_c('span',{staticClass:"empty-state-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }